import Vue from 'vue';
import Vuex from 'vuex';

import TicketModule from './ticket';
import PartnerModule from './partner';
import ProjectModule from './project';
import ProposalModule from './proposal';
import CustomerModule from './customer';
import ContactModule from './contact';
import StoreModule from './store';
import NewModule from './new';
import ProviderModule from './provider';
import AdminModule from './admin';
import EventModule from './event';
import MaterialModule from './material';
import OrderModule from './order';
import AuthenticationModule from './authentication';
import PackModule from './pack';
import PackFrontalModule from './packfrontal';
import PaymentModule from './payment';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ticket: TicketModule,
    partner: PartnerModule,
    project: ProjectModule,
    proposal: ProposalModule,
    customer: CustomerModule,
    contact: ContactModule,
    store: StoreModule,
    new: NewModule,
    provider: ProviderModule,
    admin: AdminModule,
    event: EventModule,
    material: MaterialModule,
    order: OrderModule,
    authentication: AuthenticationModule,
    pack: PackModule,
    packfrontal: PackFrontalModule,
    payment: PaymentModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js